import { useQuery } from "@tanstack/react-query";

import { useToasts } from "app/pages/activation/hooks/helpers/useToasts";
import { translate } from "app/filters/i18nFilter";
import { createActivationApi } from "app/pages/activation/services/api";

const TOPIC_QUERY_KEY = "topic";

export const useGetTopicQuery = (activationId: string, topicId: string) => {
    const { showErrorToast } = useToasts();

    return useQuery({
        queryKey: [TOPIC_QUERY_KEY, topicId],
        queryFn: async () => {
            try {
                const api = createActivationApi();

                return api.topics.getById(activationId, topicId);
            } catch (error) {
                showErrorToast(translate("common.api.error", { error: error?.message }));
            }
        },
        enabled: !!topicId && !!activationId,
    });
};
